// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import etask from '/util/etask.js';
import {PRODUCT_CODE} from '@pub/shared/constants.js';
import * as api from '@pub/api.js';

const TIMEOUT = 2000;

export const track = (event, extra={})=>etask(function*(){
    if (!event)
        return console.error('[GTM][track][error] no event name provided');
    const event_name = event.startsWith(PRODUCT_CODE)
        ? event
        : `${PRODUCT_CODE}_${event}`;
    if (!window.dataLayer)
        return console.log(`[GTM][track][ok] ${event_name}`);
    const task = this;
    requestAnimationFrame(()=>{
        window.dataLayer.push({
            event: event_name,
            ...extra,
            eventCallback: ()=>task.continue(),
            eventTimeout: TIMEOUT,
        });
    });
    yield task.wait();
});

export const handle_scheduled_events = ()=>etask(function*(){
    const list = window.embedded_data?.scheduled_gtm_events || [];
    for (const rec of list)
    {
        yield track(rec.event);
        yield api.mark_user_analytics_done(rec.event);
    }
});
